import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { MdUpload, MdLogout, MdDownload, MdRefresh, MdCloudUpload } from 'react-icons/md';
import * as XLSX from 'xlsx';
import '../../../components/css/Dashboard.css';
import { useCargaMasivaDietas } from '../../../services/hooks/useCargaMasivaDietas';
import "react-toastify/dist/ReactToastify.css";

const CargaMasivaDietas = () => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject")); // ✅ CORREGIR: Obtener de localStorage
  
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  
  const {
    loading,
    error,
    resultados,
    tiposDieta,
    procesarCargaMasiva,
    fetchTiposDieta,
    generarAyudaTiposDieta,
    limpiarResultados,
    clearError
  } = useCargaMasivaDietas();

  const showToast = (type, message) => {
    if (type === "success") {
      toast.success(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "error") {
      toast.error(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "info") {
      toast.info(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "warning") {
      toast.warning(message, { position: "bottom-right", autoClose: 3000 });
    }
  };

  useEffect(() => {
    fetchTiposDieta();
  }, [fetchTiposDieta]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      limpiarResultados();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      showToast('error', 'Por favor seleccione un archivo Excel');
      return;
    }

    // Validar que selectedProject esté disponible
    if (!selectedProject?.id) {
      showToast('error', 'No hay proyecto seleccionado. Por favor, seleccione un proyecto.');
      return;
    }

    setIsLoading(true);
    setProgress(0);

    try {
      // Simular progreso mientras se procesa
      const progressInterval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 200);

      // Enviar archivo Excel directamente al backend
      // El backend procesará, validará y cargará los datos
      await procesarCargaMasiva(file, selectedProject.id);
      
      clearInterval(progressInterval);
      setProgress(100);
      
      // El toast ya se muestra en el hook useCargaMasivaDietas
    } catch (error) {
      console.error('Error procesando archivo:', error);
      showToast('error', error.message || 'Error procesando el archivo Excel');
    } finally {
      setIsLoading(false);
      setProgress(0);
    }
  };

  const downloadTemplate = () => {
    const templateData = [
      ['numero_documento_comedor', 'id_tipo_dieta', 'fecha_inicio', 'fecha_fin'],
      ['12345678', '1', '01/01/2024', '31/12/2024'],
      ['87654321', '2', '15/01/2024', ''],
    ];

    const ws = XLSX.utils.aoa_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Plantilla Dietas');
    XLSX.writeFile(wb, 'plantilla_carga_dietas.xlsx');
    showToast("success", "Template descargado exitosamente");
  };

  const resetForm = () => {
    setFile(null);
    limpiarResultados();
    setProgress(0);
    setIsLoading(false);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';
    }
    showToast("info", "Formulario reiniciado");
  };

  return (
    <>
      <style>
        {`
          /* Estilos base Digital Harmony - Igual a CargaMasivaComensales */
          .dh-carga-bg {
            min-height: 100vh;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            padding: 1rem;
          }
          
          .dh-card-main {
            background: white;
            border-radius: 25px;
            box-shadow: 0 20px 60px rgba(0,0,0,0.15);
            overflow: hidden;
            max-width: 1200px;
            margin: 0 auto;
          }
          
          .dh-card-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 1.5rem 2rem;
            border-radius: 25px 25px 0 0;
          }
          
          .dh-header-title {
            font-size: 1.75rem;
            font-weight: 800;
            margin: 0;
            text-shadow: 0 2px 4px rgba(0,0,0,0.3);
          }
          
          .btn-dh-info {
            background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 8px 16px;
            font-weight: 600;
            font-size: 0.9rem;
            box-shadow: 0 4px 14px rgba(6, 182, 212, 0.3);
            transition: all 0.3s ease;
            cursor: pointer;
          }
          
          .btn-dh-info:hover:not(:disabled) {
            background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(6, 182, 212, 0.4);
            color: white;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 8px 16px;
            font-weight: 600;
            font-size: 0.9rem;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
            cursor: pointer;
          }
          
          .btn-dh-secondary:hover:not(:disabled) {
            background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          .btn-dh-warning {
            background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 8px 16px;
            font-weight: 600;
            font-size: 0.9rem;
            box-shadow: 0 4px 14px rgba(245, 158, 11, 0.3);
            transition: all 0.3s ease;
            cursor: pointer;
          }
          
          .btn-dh-warning:hover:not(:disabled) {
            background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
            color: white;
          }
          
          .btn-dh-warning:disabled {
            background: #9ca3af;
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
          }
          
          /* File upload section */
          .dh-upload-section {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border: 2px dashed #16a34a;
            border-radius: 15px;
            padding: 2.5rem;
            text-align: center;
            transition: all 0.3s ease;
            margin: 1.5rem 0;
          }
          
          .dh-upload-section:hover {
            border-color: #15803d;
            background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
            transform: translateY(-2px);
          }
          
          .dh-upload-section.has-file {
            border-color: #059669;
            background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
            box-shadow: 0 8px 25px rgba(16, 185, 129, 0.1);
          }
          
          .upload-icon {
            color: #16a34a;
            margin-bottom: 1rem;
          }
          
          .upload-text {
            color: #374151;
            font-size: 1.1rem;
            font-weight: 600;
            margin-bottom: 0.5rem;
          }
          
          .upload-subtext {
            color: #6b7280;
            font-size: 0.9rem;
            margin-bottom: 1.5rem;
          }
          
          .file-selected-display {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            color: white;
            padding: 12px 20px;
            border-radius: 12px;
            font-weight: 600;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin: 0.5rem;
            font-size: 1rem;
            box-shadow: 0 4px 14px rgba(5, 150, 105, 0.3);
            border: 2px solid #10b981;
            transition: all 0.3s ease;
            min-width: 180px;
            height: 44px;
          }
          
          
          .btn-submit-dh {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            border: none;
            color: white;
            border-radius: 15px;
            padding: 15px 30px;
            font-weight: 700;
            font-size: 1.1rem;
            box-shadow: 0 8px 25px rgba(5, 150, 105, 0.3);
            transition: all 0.3s ease;
            cursor: pointer;
            width: 100%;
            margin-top: 1.5rem;
          }
          
          .btn-submit-dh:hover:not(:disabled) {
            background: linear-gradient(135deg, #047857 0%, #065f46 100%);
            transform: translateY(-2px);
            box-shadow: 0 12px 35px rgba(5, 150, 105, 0.4);
          }
          
          .btn-submit-dh:disabled {
            background: #9ca3af;
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
          }
          
          /* Alert styles */
          .dh-alert-info {
            background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
            border: 2px solid #3b82f6;
            border-radius: 15px;
            padding: 1.5rem;
            margin: 1.5rem 0;
            color: #1e40af;
          }
          
          .dh-alert-warning {
            background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
            border: 2px solid #f59e0b;
            border-radius: 12px;
            padding: 1rem;
            margin-top: 1rem;
            color: #92400e;
          }
          
          /* Progress section */
          .dh-progress-section {
            background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
            border-radius: 15px;
            padding: 2rem;
            margin: 1.5rem 0;
            text-align: center;
          }
          
          .progress-dh {
            background: #e5e7eb;
            border-radius: 25px;
            height: 12px;
            overflow: hidden;
            margin: 1rem 0;
            box-shadow: inset 0 2px 4px rgba(0,0,0,0.1);
          }
          
          .progress-bar-dh {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            height: 100%;
            border-radius: 25px;
            transition: width 0.3s ease;
            box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);
          }
          
          /* Results section */
          .dh-results-card {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            border-radius: 20px;
            margin-top: 2rem;
            box-shadow: 0 8px 25px rgba(0,0,0,0.08);
            border: 2px solid #e2e8f0;
          }
          
          .dh-results-header {
            background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
            color: white;
            padding: 1.5rem 2rem;
            border-radius: 20px 20px 0 0;
          }
          
          .dh-results-body {
            padding: 2rem;
          }
          
          .dh-stat-card {
            background: white;
            border-radius: 15px;
            padding: 1.5rem;
            text-align: center;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
            transition: all 0.3s ease;
            border: 2px solid transparent;
          }
          
          .dh-stat-card:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 25px rgba(0,0,0,0.1);
            border-color: #667eea;
          }
          
          .stat-number {
            font-size: 2.5rem;
            font-weight: 800;
            margin-bottom: 0.5rem;
          }
          
          .stat-label {
            font-size: 0.9rem;
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.05em;
          }
          
          /* Error table */
          .dh-error-table {
            background: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
          }

          .dh-error-table thead {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
          }

          .dh-error-table thead th {
            color: white;
            font-weight: 700;
            padding: 1rem;
            border: none;
            font-size: 0.95rem;
          }

          .dh-error-table tbody td {
            padding: 1rem;
            border: none;
            border-bottom: 1px solid #f3f4f6;
            vertical-align: top;
          }

          .dh-error-table tbody tr:hover {
            background-color: #fef2f2;
          }
        `}
      </style>
      
      <div className="dh-carga-bg">
        <div className="container-fluid py-4">
          <ToastContainer />
          <div className="dh-card-main">
            <div className="dh-card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="dh-header-title">Carga Masiva de Dietas</h5>
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn-dh-info d-flex align-items-center gap-2"
                    onClick={downloadTemplate}
                    title="Descargar plantilla Excel"
                  >
                    <MdDownload size={20} />
                    Descargar Template
                  </button>
                  <button
                    type="button"
                    className="btn-dh-warning d-flex align-items-center gap-2"
                    onClick={resetForm}
                    disabled={isLoading}
                    title="Limpiar formulario"
                  >
                    <MdRefresh size={20} />
                    Limpiar
                  </button>
                  <button
                    type="button"
                    className="btn-dh-secondary d-flex align-items-center gap-2"
                    onClick={() => navigate('/dashboard')}
                    title="Volver al Dashboard"
                  >
                    <MdLogout size={20} />
                    Salir
                  </button>
                </div>
              </div>
            </div>

            <div className="p-4">
              <form onSubmit={handleSubmit}>
                {/* Sección de carga de archivo */}
                <div className="row mb-4">
                  <div className="col-12">
                    <div className={`dh-upload-section ${file ? 'has-file' : ''}`}>
                      {!file ? (
                        <>
                          <MdCloudUpload size={64} className="upload-icon" />
                          <div className="upload-text">Seleccionar archivo Excel</div>
                          <div className="upload-subtext">
                            Formatos soportados: .xlsx, .xls (máximo 10MB)
                          </div>
                          <label className="btn-dh-info" style={{ cursor: 'pointer' }}>
                            <MdUpload size={20} className="me-2" />
                            Examinar Archivos
                            <input
                              type="file"
                              accept=".xlsx,.xls"
                              onChange={handleFileChange}
                              style={{ display: 'none' }}
                              disabled={isLoading}
                            />
                          </label>
                        </>
                      ) : (
                        <>
                          <div className="upload-text">Archivo seleccionado correctamente</div>
                          <div className="upload-subtext">
                            <strong>Archivo cargado:</strong>
                          </div>
                          <div className="d-flex flex-column align-items-center">
                            <div className="file-selected-display">
                              <i className="fas fa-file-excel me-2"></i>
                              {file.name}
                            </div>
                            <button
                              type="button"
                              className="btn-dh-warning"
                              onClick={() => {
                                setFile(null);
                                limpiarResultados();
                                const fileInput = document.querySelector('input[type="file"]');
                                if (fileInput) {
                                  fileInput.value = '';
                                }
                              }}
                              disabled={isLoading}
                            >
                              <i className="fas fa-times me-2"></i>
                              Cambiar Archivo
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Instrucciones */}
                <div className="dh-alert-info">
                  <h6 className="fw-bold mb-3">
                    <i className="fas fa-info-circle me-2"></i>
                    Formato del archivo Excel
                  </h6>
                  <p className="mb-3">El archivo debe tener las siguientes columnas en este orden exacto:</p>
                  <div className="row">
                    <div className="col-md-6">
                      <ol className="mb-2">
                        <li><strong>Número Documento Comedor</strong> <span className="text-danger">(requerido)</span></li>
                        <li><strong>ID Tipo Dieta</strong> <span className="text-danger">(requerido)</span></li>
                      </ol>
                    </div>
                    <div className="col-md-6">
                      <ol start="3" className="mb-2">
                        <li><strong>Fecha Inicio</strong> <span className="text-danger">(requerido, DD/MM/YYYY)</span></li>
                        <li><strong>Fecha Fin</strong> <span className="text-muted">(opcional, DD/MM/YYYY)</span></li>
                      </ol>
                    </div>
                  </div>
                  
                  {tiposDieta.length > 0 && (
                    <div className="dh-alert-warning">
                      <small>
                        <strong>Tipos de Dieta Disponibles:</strong><br/>
                        {tiposDieta.map(tipo => `${tipo.id}: ${tipo.nombre}`).join(', ')}
                      </small>
                    </div>
                  )}
                </div>

                {/* Botón de envío */}
                <button
                  type="submit"
                  className="btn-submit-dh d-flex align-items-center justify-content-center gap-2"
                  disabled={isLoading || !file}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Procesando archivo...
                    </>
                  ) : (
                    <>
                      <MdUpload size={24} />
                      Cargar Dietas
                    </>
                  )}
                </button>
              </form>

              {/* Barra de progreso */}
              {isLoading && (
                <div className="dh-progress-section">
                  <h6 className="fw-bold mb-3 text-center">
                    <i className="fas fa-cog fa-spin me-2"></i>
                    Procesando archivo...
                  </h6>
                  <div className="progress-dh">
                    <div
                      className="progress-bar-dh progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      style={{ width: `${progress}%` }}
                      aria-valuenow={progress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div className="text-center">
                    <span className="fw-bold">{progress}% completado</span>
                  </div>
                </div>
              )}

              {/* Resultados */}
              {resultados && (
                <div className="dh-results-card">
                  <div className="dh-results-header">
                    <h5 className="mb-0 fw-bold">
                      <i className="fas fa-chart-bar me-2"></i>
                      Resultados de la Carga
                    </h5>
                  </div>
                  <div className="dh-results-body">
                    {resultados.bloqueo_documento_sin_comensal && (
                      <div className="alert alert-danger mb-4" role="alert">
                        <h6 className="alert-heading fw-bold mb-2">
                          <i className="fas fa-ban me-2" />
                          Carga rechazada
                        </h6>
                        <p className="mb-0">
                          {resultados.mensaje_bloqueo ||
                            'No se guardó ningún registro. Corrija los documentos sin comensal registrado y vuelva a cargar.'}
                        </p>
                      </div>
                    )}
                    {/* Primera fila - Total */}
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <div className="dh-stat-card" style={{backgroundColor: '#f8f9fa', border: '2px solid #dee2e6'}}>
                          <div className="stat-number text-primary" style={{fontSize: '3rem'}}>{resultados.total_procesados}</div>
                          <div className="stat-label" style={{fontSize: '1.1rem', fontWeight: 'bold'}}>TOTAL PROCESADOS</div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Segunda fila - Detalles */}
                    <div className="row">
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-success">{resultados.nuevos}</div>
                          <div className="stat-label">Dieta agregada</div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-info">{resultados.actualizados}</div>
                          <div className="stat-label">Actualizados</div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-warning">
                            {resultados.omitidos_dieta_activa ?? 0}
                          </div>
                          <div className="stat-label">Ya con dieta activa</div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-danger">{resultados.errores}</div>
                          <div className="stat-label">Errores</div>
                        </div>
                      </div>
                    </div>

                    {(resultados.comensales_dieta_agregada?.length > 0 ||
                      (resultados.omitidos_dieta_activa ?? 0) > 0) && (
                      <div className="row mt-2">
                        {resultados.comensales_dieta_agregada?.length > 0 && (
                          <div className="col-lg-6 mb-4">
                            <div className="alert alert-success mb-0">
                              <h6 className="alert-heading fw-bold mb-3">
                                <i className="fas fa-user-check me-2" />
                                Comensales a los que se agregó la dieta ({resultados.comensales_dieta_agregada.length})
                              </h6>
                              <div className="table-responsive" style={{ maxHeight: '280px', overflowY: 'auto' }}>
                                <table className="table table-sm table-bordered mb-0 bg-white">
                                  <thead className="table-light">
                                    <tr>
                                      <th>Fila</th>
                                      <th>Comensal</th>
                                      <th>Documento</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {resultados.comensales_dieta_agregada.map((row, idx) => (
                                      <tr key={`ag-${idx}`}>
                                        <td>{row.fila}</td>
                                        <td>{row.comensal}</td>
                                        <td>{row.numero_documento_comedor}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                        {(resultados.omitidos_dieta_activa ?? 0) > 0 &&
                          resultados.comensales_ya_con_dieta_activa?.length > 0 && (
                            <div className="col-lg-6 mb-4">
                              <div className="dh-alert dh-alert-info mb-0">
                                <h6 className="fw-bold mb-3">
                                  <i className="fas fa-info-circle me-2" />
                                  Comensales que ya tenían dieta activa (no se modificó) (
                                  {resultados.comensales_ya_con_dieta_activa.length})
                                </h6>
                                <div className="table-responsive" style={{ maxHeight: '280px', overflowY: 'auto' }}>
                                  <table className="table table-sm table-bordered mb-0 bg-white">
                                    <thead className="table-light">
                                      <tr>
                                        <th>Fila</th>
                                        <th>Comensal</th>
                                        <th>Documento</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {resultados.comensales_ya_con_dieta_activa.map((row, idx) => (
                                        <tr key={`omit-${idx}`}>
                                          <td>{row.fila}</td>
                                          <td>{row.comensal}</td>
                                          <td>{row.numero_documento_comedor}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    )}

                    {/* Detalles de errores */}
                    {resultados.errores > 0 ? (
                      resultados.detalles && resultados.detalles.length > 0 && (
                        <div className="mt-4">
                          <div className="alert alert-danger">
                            <h6 className="alert-heading fw-bold">
                              <i className="fas fa-exclamation-triangle me-2"></i>
                              Errores Encontrados ({resultados.detalles.length} registros con problemas)
                            </h6>
                            <div className="table-responsive mt-3">
                              <table className="dh-error-table table mb-0">
                                <thead>
                                  <tr>
                                    <th style={{ width: '100px' }}>📍 Fila</th>
                                    <th>🚫 Error</th>
                                    <th>📄 Documento</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {resultados.detalles.map((detalle, index) => (
                                    <tr key={index}>
                                      <td className="fw-bold text-center">
                                        <span className="badge bg-danger fs-6">{detalle.fila}</span>
                                      </td>
                                      <td>
                                        <i className="fas fa-times-circle text-danger me-2"></i>
                                        {detalle.message}
                                      </td>
                                      <td>{detalle.data?.numero_documento_comedor}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )
                    ) : (
                      <div className="text-center text-success mt-3">
                        <i className="fas fa-check-circle me-2"></i>
                        <strong>
                          {(resultados.omitidos_dieta_activa ?? 0) > 0
                            ? 'Carga finalizada sin errores. Revise el detalle de omitidos por dieta activa arriba.'
                            : '¡Excelente! Todos los registros se procesaron correctamente sin errores.'}
                        </strong>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CargaMasivaDietas;
